import React from "react";
import Page from "../../components/Page";

import CenteredPageContentContainer from "../../components/CenteredPageContentContainer";
import PaperContainer from "../../components/PaperContainer";
import ProjectForm from "../../components/forms/ProjectForm";
import { FormMode } from "../../types/enums";

const CreateProjectPage = () => (
  <Page enableGoBack title="Project toevoegen">
    <CenteredPageContentContainer>
      <PaperContainer title="Project toevoegen">
        <ProjectForm mode={FormMode.CREATE} />
      </PaperContainer>
    </CenteredPageContentContainer>
  </Page>
);

export default CreateProjectPage;



// WEBPACK FOOTER //
// ./src/pages/Project/CreateProjectPage.js